// extracted by css-extract-rspack-plugin
export default {"cardBorder":"Ki3SP1K1TSkx96PR"};